<template>
  <div>
    <router-link
    :to="{name: 'RubricVersions', params: {rid: params.data.id }}">
        {{ params.data.name }}
    </router-link>
  </div>
</template>

<script lang="js">
import Vue from 'vue';

export default Vue.extend({
  data: function () {
    return {
    }
  }
})
</script>